import { useLayoutEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";
import { Leaf, X } from "lucide-react";
import { Link } from "@/lib/router-compat";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "gr-promo-banner-dismissed-scarifying-2026-10";
const TARGET_HREF = "/scarifiers";

/**
 * Temporary site-wide TOP promo bar. Hide it by setting
 * HIDDEN_PATHS or removing this component from src/routes/__root.tsx.
 */
const HIDDEN_PATHS = ["/admin", TARGET_HREF];

const PromoBanner = () => {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const [visible, setVisible] = useState(false);

  useLayoutEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") return;
    setVisible(true);
  }, []);

  if (!visible) return null;
  if (HIDDEN_PATHS.some((p) => pathname.startsWith(p))) return null;

  return (
    <div
      className="relative bg-primary text-primary-foreground"
      role="complementary"
      aria-label="Current promotion"
    >
      <div className="container mx-auto pl-4 pr-12 max-w-6xl flex items-center justify-center gap-2 sm:gap-3 py-2.5 text-sm">
        <Leaf className="h-4 w-4 shrink-0 hidden sm:block" aria-hidden="true" />
        <span className="min-w-0 font-semibold break-words">
          Scarifying: what to know &amp; the best scarifiers
        </span>
        <Button asChild variant="secondary" size="sm" className="h-auto shrink-0 px-2.5 py-1 text-xs font-bold">
        <Link
          to={TARGET_HREF}
        >
          Read the guide
        </Link>
        </Button>
      </div>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => {
          sessionStorage.setItem(STORAGE_KEY, "1");
          setVisible(false);
        }}
        aria-label="Dismiss promotion"
        className="absolute right-1.5 top-1/2 -translate-y-1/2 h-8 w-8 text-primary-foreground hover:text-primary-foreground hover:bg-primary-foreground/15"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </Button>
    </div>
  );
};

export default PromoBanner;
